import React, { useEffect } from "react";
import { IAdminFireBase } from "@/store/models/admin.models";
import { withAdmin } from "@/services/withAdmin";
import {
  useCheckIsAdminLoginQuery,
  useCreateAdminMutation,
} from "@/store/rtk-api/admin.api";
import Layout from "@/components/Layout/Layout";
import MainContent from "./components/HeaderHome/MainContent/MainContent";

const HomePageCmp: React.FC<{ admin: IAdminFireBase }> = ({ admin }) => {
  const { data: isAdminLogin } = useCheckIsAdminLoginQuery({
    email: admin.email,
  });

  const [createAdmin] = useCreateAdminMutation();

  useEffect(() => {
    if (isAdminLogin?.isAdmin === false) {
      createAdmin({
        emails: [admin.email],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout admin={admin} pageNav={false}>
      <MainContent />
    </Layout>
  );
};

export const HomePage = withAdmin(HomePageCmp);
HomePageCmp.displayName = "HomePageCmp";

